<template>
    <xm-input id="password-field" v-model="val" :type="showPass?'text':'password'" autocomplete="false" :maxlength="maxlength" :label="label">
    <span slot="after" class="input-group-append" @click="updateShowPass(!showPass)">
      <span class="input-group-text" >
        <i class="bi icon-sizing" :class="showPass?'bi-eye-slash-fill':'bi-eye-fill'"></i>
      </span>
    </span>
  </xm-input>
</template>


<style scoped>
.input-group-text {
  background: white;
  color: #495057;
  border: 1px solid #ced4da;
  border-radius: .25rem;
}
.input-group-append {
  margin-left:0
}

.icon-sizing {
  font-size: 125%;
  margin-top: -5px;
  margin-bottom: -5px;
}


</style>

<script>

import XmInput from "./XmInput.vue";


export default {
  data () {
    return {
      showPass: false,
      val: this.value
    }
  },

  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    help: {
      type: String,
      required: false,
      default: ''
    },
    minlength: {
      type: Number,
      required: false,
      default: 0
    },
    maxlength: {
      type: Number,
      required: false,
      default: null
    },
  },

  methods: {
    updateShowPass (val) {
      this.showPass = val
      this.$emit('toggle', val)
    },
  },
  watch: {
    val (val) {
      this.$emit('input', val);
    },
    value (val) {
      this.val = val;
    }
  },
  components: {
    XmInput
  }
}
</script>



// WEBPACK FOOTER //
// ShowPasswordField.vue?5590856b